import React, { Fragment } from "react"
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { isMobile } from "../isMobile"

import {
  Paper,
  Typography,
  Stepper as MuiStepper,
  Step,
  StepLabel,
  StepContent,
  Button
} from '@material-ui/core'

const styles = theme => ({
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  stepper: {
    padding: (isMobile() ? 0 : theme.spacing(3)),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  img: {
    margin: theme.spacing(2),
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: '5px',
    maxWidth: '100%',
  },
})

@withStyles(styles)
export default class Stepper extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeStep: 0,
    }
  }

  handleNext = () => {
    this.setState({ activeStep: this.state.activeStep + 1 })
  }

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 })
  }

  handleReset = () => {
    this.setState({ activeStep: 0 })
  }

  render() {
    const { classes } = this.props
    const nbSteps = this.props.steps.length
    return (
      <Fragment>
        <MuiStepper className={classes.stepper} activeStep={this.state.activeStep} orientation="vertical">
          {this.props.steps.map((s, index) => (
            <Step key={index}>
              <StepLabel>{s.label}</StepLabel>
              <StepContent>
                <div className={classes.parag}>
                  {s.content}
                </div>
                {s.img !== '' && <img className={classes.img} src={s.img} />}
                <div>
                  {this.state.activeStep > 0 && <Button disabled={this.state.activeStep === 0} onClick={this.handleBack}>Back</Button>}
                  {(this.state.activeStep === nbSteps - 1) && this.props.lastStep}
                  {this.state.activeStep < nbSteps - 1 && <Button variant="contained" color="primary" onClick={this.handleNext}>{(this.state.activeStep === nbSteps - 1) ? 'Finish' : 'Next'}</Button>}
                </div>
              </StepContent>
            </Step>
          ))}
        </MuiStepper>
        {(this.state.activeStep === (nbSteps - 1)) && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <Typography>All steps completed - you&apos;re done</Typography>
            <Button onClick={this.handleReset}>
              Reset
            </Button>
          </Paper>
        )}
      </Fragment>
    )
  }
}

Stepper.propTypes = {
  steps: PropTypes.object.isRequired,
}
